<template>
  <div>
    <v-toolbar color="secondary" flat>
      <v-btn icon @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('Auswertung Detailansicht (Nur Lesezugriff)') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip color="warning" class="mr-4">{{ $t('Schreibgeschützt') }}</v-chip>
    </v-toolbar>
    <!-- Wir betten hier die InspectionPointView ein, müssen aber sicherstellen, dass sie im Read-Only Modus ist -->
    <InspectionPointView :readOnly="true" />
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router';
import InspectionPointView from '../InspectionPointView.vue';

export default {
  name: 'EvaluationDetailView',
  components: {
    InspectionPointView
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const userId = route.params.userId;

    const goBack = () => {
      router.push({ name: 'EvaluationUserTests', params: { userId: userId } });
    };

    return {
      goBack
    };
  }
};
</script>
